<template>
  <div class="main">
    <el-form class="login-form" :model="form" >
      <el-form-item class="login-form-item">
        <el-input v-model="form.userName" placeholder="请输入账号" :rules="[
          { required: true, message: '账号不能为空'},
        ]"></el-input>
      </el-form-item>
      <el-form-item class="login-form-item">
        <el-input type="password" v-model="form.passWord" placeholder="请输入密码" @keyup.enter.native="subLogin" :rules="[
          { required: true, message: '密码不能为空'},
        ]"></el-input>
      </el-form-item>
      <div class="sub-btn" @click="subLogin">登录</div>
    </el-form>
  </div>
</template>
<script>
export default {
  data () {
    return {
      form: {
        userName: '',
        passWord: ''
      }
    }
  },
  methods: {
    subLogin () {
      this.$http.post('/admin/dashu/login', {
       username:this.form.userName,
       password:this.form.passWord,
      }).then( (res)=> {
        var code=res.data.code;
        if(code===0){
          var token=res.data.data.token;
          window.localStorage.setItem('user_token', token)
          this.$router.push({ path: '/backHome'})
            }else if(code===-1){
                this.$alert('用户名或密码错误！', '错误！', {
                    confirmButtonText: '确定',
            });
        }
      }).catch(function (error) {
        //  console.log(error);
     });
   },
   
  },
  created(){
   
  }
}
</script>
<style scoped>
.main {
  height: 100vh;
  background: url('../../assets/backlogin.jpg') no-repeat;
  overflow: hidden;
  background-size: cover;
  background-position: center center;
}
.login-form {
  width: 500px;
  margin: 20% auto;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 20px 0;
  border-radius: 10px;
  box-shadow: 0 0 10px 1px #666;
  /* box-shadow: 0 0 5px 2px #fff inset; */
}
.login-form-item {
  background-color: rgba(255, 255, 255, 0);
}
.el-form .is-checked {
  background-color: #000;
}
.login-form-item {
  width: 80%;
  margin: 20px auto;
  /* border-bottom: 1px solid #fff; */
}
.login-form-item input{
  background-color: rgba(0, 0, 0, 0.1);
  color: #fff;
  border: 0;
  text-align: center;
  /* font-size: 16px;
  background-color: rgba(255, 255, 255, 0);
  color: #fff;
  text-align: center;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #fff; */
}
.login-form-item input::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.8);
}
.login-form-item input:--moz-placeholder {
  color: rgba(255, 255, 255, 0.8);
}
.login-form-item input::-moz-placeholder {
  color: rgba(255, 255, 255, 0.8);
}
.login-form-item input::-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.8);
}
.sub-btn {
  width: 80%;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  text-align: center;
  margin: 20px auto;
  color: #fff;
  background-color: #ffd147;
  border-radius: 5px;
  cursor: pointer;
}
.sub-btn:active {
  box-shadow: 0 0 2px 1px #ddbb55 inset;
}
</style>



// WEBPACK FOOTER //
// src/pages/backPages/login.vue